/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/util/sanitizeAddress */
import{derivePrefix as i}from"./derivePublicKeyHash.mjs";function n(e){return e.includes(":")?e:`${i(e)}:${e}`}export{n as sanitizeAddress};
//# sourceMappingURL=sanitizeAddress.mjs.map